import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "../api";
import { getToken } from "../models/users.models";
import { ICreateMusicDTO } from "../models/music.models";
import { ICreateVideoDTO } from "../models/video.models";

const mediaUploadConfig = {
  ...baseQueryConfig,
  baseUrl: baseQueryConfig.baseUrl + "/media-upload",
  prepareHeaders: (headers: Headers) => {
    const session = getToken();
    if (session && session.token) {
      headers.set("Authorization", `Bearer ${session.token}`);
    }
    return headers;
  },
};

export const mediaUploadApi = createApi({
  reducerPath: "mediaUploadApi",
  tagTypes: ["MediaUpload"],
  baseQuery: fetchBaseQuery(mediaUploadConfig),
  endpoints: (builder) => ({
    uploadVideo: builder.mutation<
      { id: number; data: ICreateVideoDTO },
      FormData
    >({
      query: (formData) => ({
        url: "/single-video",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["MediaUpload"],
    }),
    uploadAudio: builder.mutation<
      { id: number; data: ICreateMusicDTO },
      FormData
    >({
      query: (formData) => ({
        url: "/single-music",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["MediaUpload"],
      transformResponse: (response: { id: number; data: ICreateMusicDTO }) => ({
        id: response.id,
        data: response.data,
      }),
    }),
    uploadMediaFromCsv: builder.mutation<void, FormData>({
      query: (data) => ({
        url: "/from-csv",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["MediaUpload"],
    }),
    getUploadMedia: builder.query<any, { jobUid: number }>({
      query: ({ jobUid }) => ({
        url: `/${jobUid}`,
      }),
      providesTags: ["MediaUpload"],
    }),
    getJobsPending: builder.query<any, void>({
      query: () => ({
        url: "/jobs/pending",
      }),
      providesTags: ["MediaUpload"],
    }),
  }),
});

export const {
  useUploadAudioMutation,
  useUploadVideoMutation,
  useUploadMediaFromCsvMutation,
  useGetUploadMediaQuery,
  useGetJobsPendingQuery,
} = mediaUploadApi;

